import { render, staticRenderFns } from "./OpeningHoursSelector.vue?vue&type=template&id=d0ba45c4&xmlns%3ASortedTable=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./opening-hours-selector.js?vue&type=script&lang=js&external"
export * from "./opening-hours-selector.js?vue&type=script&lang=js&external"
import style0 from "./opening-hours-selector.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports